// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"5eb247cd","71":"6a426d0e","228":"cb050ffa","246":"b1f724e7","291":"bb6e5143","330":"7f02d7a0","415":"77dd7ef4","586":"c03b43f9","713":"72e1b0e7","860":"baeb4845","906":"c093ae5e"}[chunkId] + ".chunk.js";
};